<template>
  <div class="toolbar-bottom">
    <div class="toolbar">
      <!--       <div class="toolbar-button">
        <v-menu v-if="$store.state.mainMenu.length > 0" offset-y top>
          <template v-slot:activator="{ on, attrs }">
            <div
              v-show="mainMenuCatSelected != null"
              class="toolbar-button-text"
              v-bind="attrs"
              v-on="on"
            >
              {{ $store.getters.categoryDescr(mainMenuCatSelected) }}
            </div>
          </template>
          <v-list>
            <v-list-item v-for="(cat, index) in $store.state.mainMenu" :key="index" @click="mainMenuCatClicked(cat)">
              <v-list-item-title>{{ $store.getters.categoryDescr(cat) }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div> -->

      <div v-if="showLangageSwitcher" class="toolbar-button" @click="setNextLanguage">
        <LanguageIcon></LanguageIcon>
      </div>

      <!--       
      <div v-if="showOrderType" class="toolbar-orertype-button" @click="setNextLanguage">
        <v-icon>{{ orderTypeIcon }}</v-icon>
      </div> 
      -->

      <div v-if="showOrderType" class="toolbar-button"></div>
      <v-menu v-if="showOrderType" top auto offset-y close-on-content-click>
        <template v-slot:activator="{ on, attrs }">
          <div class="toolbar-ordertype-button" text v-bind="attrs" v-on="on">
            <v-icon>{{ orderTypeIcon }}</v-icon>
          </div>
        </template>

        <v-list>
          <v-list-item v-for="(obj, index) in orderTypeList" :key="index" @click="switchOrderType(obj.orderType)">
            <v-list-item-title>{{ $t(obj.title) }}</v-list-item-title>
          </v-list-item>
          <!--           
          <v-list-item v-if="showDineinButton" @click="switchOrderType($store.state.OT_DINEIN)">
            <v-list-item-title>{{ $t("dinein") }}</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="showTakeoutButton" @click="switchOrderType($store.state.OT_TAKEOUT)">
            <v-list-item-title>{{ $t("takeout") }}</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="showDeliveryButton" @click="switchOrderType($store.state.OT_DELIVERY)">
            <v-list-item-title>{{ $t("delivery") }}</v-list-item-title>
          </v-list-item> 
        -->
        </v-list>
      </v-menu>

      <div v-if="showPromo" class="toolbar-button" @click="openPromoClicked">
        <v-badge color="accent" dot :value="this.$store.state.promos.length > 0" offset-y="8">
          <v-icon>mdi-ticket-percent-outline</v-icon
          ><span v-show="showTitle" class="toolbar-button-text">{{ $t("promotion") }}</span>
        </v-badge>
      </div>

      <div class="toolbar-button" @click="searchItem">
        <v-icon>mdi-magnify</v-icon><span v-show="showTitle" class="toolbar-button-text">{{ $t("search") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageIcon from "@/components/LanguageIcon.vue";
export default {
  components: {
    LanguageIcon,
  },

  props: {
    mainMenuCatSelected: null,
  },

  computed: {
    showTitle() {
      return true;
    },

    showLangageSwitcher() {
      return this.$store.getters.languages.length > 1 && this.$appMode == 0;
    },

    showOrderType() {
      /*
      return [this.$store.state.OT_DINEIN, this.$store.state.OT_TAKEOUT, this.$store.state.OT_DELIVERY].includes(
        this.$store.state.order.orderType
      ) && this.$appMode==1;
      */
      return this.$appMode == 1 && this.orderTypeList.length > 0;
    },

    showPromo() {
      return false; //this.$store.state.promos.length > 0;
    },

    orderTypeList() {
      let list = [];
      if (this.showDineinButton) list.push({ orderType: this.$store.state.OT_DINEIN, title: "dinein" });
      if (this.showTakeoutButton) list.push({ orderType: this.$store.state.OT_TAKEOUT, title: "takeout" });
      if (this.showDeliveryButton) list.push({ orderType: this.$store.state.OT_DELIVERY, title: "delivery" }); 
      return list;
    },

    orderTypeIcon() {
      if (this.$store.state.order.orderType == this.$store.state.OT_DINEIN) return "mdi-silverware-fork-knife";
      else if (this.$store.state.order.orderType == this.$store.state.OT_TAKEOUT) return "mdi-shopping";
      else if (this.$store.state.order.orderType == this.$store.state.OT_DELIVERY) return "mdi-moped";
      else return "";
    },

    showDineinButton() {
      if (
        this.$store.state.order.orderType != this.$store.state.OT_DINEIN &&
        this.$store.state.store != null &&
        this.$store.state.store.orderType != null &&
        this.$store.state.store.orderType.dinein != null
      ) {
        let om = this.$store.state.store.orderType.dinein;
        return om.tableGroupID > 0 || om.askTableName;
      } else return false;
    },

    showTakeoutButton() {
      if (
        this.$store.state.order.orderType != this.$store.state.OT_TAKEOUT &&
        this.$store.state.store != null &&
        this.$store.state.store.orderType != null &&
        this.$store.state.store.orderType.takeout != null
      ) {
        let om = this.$store.state.store.orderType.takeout;
        return om.tableGroupID > 0;
      } else return false;
    },

    showDeliveryButton() {
      if (
        this.$store.state.order.orderType != this.$store.state.OT_DELIVERY &&
        this.$store.state.store != null &&
        this.$store.state.store.orderType != null &&
        this.$store.state.store.orderType.delivery != null
      ) {
        let om = this.$store.state.store.orderType.delivery;
        return om.tableGroupID > 0;
      } else return false;
    },
  },

  methods: {
    searchItem() {
      if (this.$store.state.orderMenu != null && this.$store.state.orderMenu == 1) this.searchRedeemItem();
      else this.searchMenuItem();
    },

    openPromoClicked() {
      this.openPromoDialog();
    },

    openPromoDialog() {
      this.$root.memberPromoDialog();
    },

    mainMenuCatClicked(cat) {
      this.$emit("mainMenuCatClicked", cat);
    },

    async switchOrderType(orderType) {
      let confirmed = await this.confirmSwitchOrderType(orderType);
      if (confirmed) {
        this.$emit("orderTypeSwitched", orderType);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.toolbar-bottom {
  z-index: 3;
  display: flex;
  justify-content: center;
  position: fixed;
  //bottom: calc(20px + env(safe-area-inset-bottom));
  bottom: calc(20px + #{$bottom-toolbar-height});
  width: 100%;

  .toolbar-button + .toolbar-button:before {
    content: " | ";
    padding: 0 10px;
  }

  .toolbar-button + .tt1:after {
    content: " | ";
    padding: 0 10px;
  }

  .toolbar {
    background-color: var(--v-primary-base);
    color: var(--v-primaryText-base);
    padding: 8px 16px 8px 16px;
    border-radius: 40px;
    display: flex;
    justify-content: center;
    //box-shadow: 2px 2px 2px var(--v-primary-lighten5);
    box-shadow: 2px 2px 2px lightgrey;

    .toolbar-button {
      align-items: center;
      display: inline-flex;

      .v-icon {
        color: var(--v-primaryText-base);
      }

      .toolbar-button-text {
        font-size: 0.8em; //0.7em;
        letter-spacing: 1px;
        text-transform: uppercase;
        padding-left: 4px;
      }
    }

    .toolbar-ordertype-button {
      @extend .toolbar-button;

      .v-icon {
        font-size: 1em;
        padding-right: 8px;
        padding-left: 8px;
      }
    }
  }
}
</style>
